<template>
  <div class="mx-3">
    <v-row>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in policy here"
          append-icon="search"
          label="Search Policy"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <!-- do not remove the border='' below -->
    <!-- css purpose -->
    <v-data-table
      border=""
      :headers="headers"
      :items="jobGroupPolicyClaims"
      :loading="tableLoading"
      :search="search"
      show-expand
      :single-expand="true"
      class="remove-box-shadow"
    >
      <template v-slot:item.action="{ item }">
        <setup-claims-claim-policy-dialog-edit
          v-if="$hasPermissionTo(['update claim policies'])"
          :job-group-policy="item"
          @updated="loadData"
        />
      </template> 

      <template v-slot:expanded-item="{ headers,item }">
        <td
          :colspan="headers.length"
          class="py-2"
          style="background-color: rgba(0, 0, 0, .05);"
        >
          <!-- <v-chip
            v-for="claim in item.job_group_policy_claims"
            :key="claim.id"
            small
            class="text--primary mx-1 my-1"
          >
            {{ (claim.claimable || {}).name }}
          </v-chip> -->

          <v-data-table
            hide-default-footer
            style="border:1px solid #e6e6e6"
            dense
            class="mt-2"
            :items="getSortedClaims(item.job_group_policy_claims)"
            :headers="claimsHeaders"
            :loading="tableLoading"
            :items-per-page="-1"
          >
            <template v-slot:item.name="{ item }">
              <span>{{ (item.claimable || {}).name }}</span>
            </template>

            <template v-slot:item.claimable_type="{ item }">
              <span>{{ item.claimable.claim_type_id ? 'Claim Entitlement Setting' : 'Claim Type' }}</span>
            </template>

            <template v-slot:item.end_date="{ item }">
              <span>{{ item.end_date ? item.end_date : 'N/A' }}</span>
            </template>
            
            <template v-slot:item.action="{ item }">
              <setup-claims-claim-policy-claim-dialog-edit
                v-if="$hasPermissionTo(['update claim policies'])"
                :job-group-policy-claim="item"
                @updated="loadData"
              />
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupClaimsClaimPolicyDialogEdit: () => import('@/components/hris/setup/claims/claim-policy/DialogEdit'),
      SetupClaimsClaimPolicyClaimDialogEdit: () => import('@/components/hris/setup/claims/claim-policy/claim/DialogEdit'),
    },
    data () {
      return {
        jobGroupPolicyClaims: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Cutoff Type',
            align: 'left',
            value: 'cutoff_type.name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        claimsHeaders: [
          {
            text: 'Claim',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Type',
            align: 'left',
            value: 'claimable_type',
          },
          {
            text: 'Start Date',
            align: 'center',
            value: 'start_date',
          },
          {
            text: 'End Date',
            align: 'center',
            value: 'end_date',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.$api.claimPolicies().list()
          .then(res => {
            this.jobGroupPolicyClaims = res.data
            this.$emit('loaded')
            this.tableLoading = false
          })
      },
      getSortedClaims (claims) {
        return claims.slice().sort((a, b) =>
          a.claimable.name.localeCompare(b.claimable.name)
        )
      },
    },
  }
</script>

<style scoped>
.remove-box-shadow >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__content{
  box-shadow: unset !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row{
  background-color: rgba(0, 0, 0, .05) !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-start{
  border:0px !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-left{
  border:0px !important;
}
</style>
